import BaseMessageBarError from '@/base/MessageBar/Error';
import { UiButton, UiHStack } from '@/lib/ui';
import { useBoolean } from '@chakra-ui/react';
import type React from 'react';
import { useEffect } from 'react';
import { useScript } from 'usehooks-ts';

interface EwayPaymentIframeProps {
  isLoading: boolean
  isDisabled: boolean
  sharedPaymentUrl: string
  resultCallback: (result: string, transactionID: string, errors: string) => void
}

const EwayPaymentIframe: React.FC<EwayPaymentIframeProps> = ({ isLoading, isDisabled, sharedPaymentUrl, resultCallback }) => {
  // state loading
  const [loadingModalPayment, { on: showLoadingModalPayment, off: hideLoadingModalPayment }] = useBoolean(false);
  useEffect(() => {
    if (loadingModalPayment) {
      setTimeout(() => {
        hideLoadingModalPayment();
      }, 4000);
    }
  }, [hideLoadingModalPayment, loadingModalPayment]);

  const scriptStatus = useScript('https://secure.ewaypayments.com/scripts/eCrypt.min.js');
  const onClickPayNow = () => {
    if (!loadingModalPayment) {
      showLoadingModalPayment();
      (window as any).eCrypt.showModalPayment(
        {
          sharedPaymentUrl: `${sharedPaymentUrl}`
        },
        resultCallback
      );
    }
  };

  return (
    <UiHStack justifyContent='flex-end'>
      {scriptStatus === 'error'
        ? <BaseMessageBarError>
        Something went wrong
        </BaseMessageBarError>
        : <UiButton
          isDisabled={isDisabled}
          isLoading={isLoading || loadingModalPayment || scriptStatus === 'loading'}
          onClick={onClickPayNow}>Pay now</UiButton>
      }
    </UiHStack>
  );
};

export default EwayPaymentIframe;
